export default __webpack_public_path__ + "static/media/logo_suma_eslogan.369e2742.svg";